import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M7 10a7 7 0 1 0 14 0a7 7 0 1 0 -14 0","key":"svg-0"}],["path",{"d":"M21 10a3.5 3.5 0 0 0 -7 0","key":"svg-1"}],["path",{"d":"M14 10a3.5 3.5 0 0 1 -7 0","key":"svg-2"}],["path",{"d":"M14 17a3.5 3.5 0 0 0 0 -7","key":"svg-3"}],["path",{"d":"M14 3a3.5 3.5 0 0 0 0 7","key":"svg-4"}],["path",{"d":"M3 21l6 -6","key":"svg-5"}]]

const IconLollipop = createReactComponent('outline', 'lollipop', 'Lollipop', __iconNode);

export default IconLollipop;